import { useCallback, useEffect, useState } from "react";
import apiFetch from "../api";

export default function useTodosData(user_id) {
  const [todos, setTodos] = useState([]);
  const [nextPlan, setNextPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    try {
      setError(null);
      const [listRes, nextRes] = await Promise.all([
        apiFetch(`/${user_id}/todo`),
        apiFetch(`/next_actions?n=5&available_minutes=45`),
      ]);
      if (!listRes.ok) throw new Error("Could not load tasks");
      const listJson = await listRes.json();
      setTodos(listJson.todos || []);
      if (nextRes.ok) {
        setNextPlan(await nextRes.json());
      } else {
        setNextPlan(null);
      }
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  }, [user_id]);

  useEffect(() => {
    refresh();
    const interval = setInterval(refresh, 60_000);
    return () => clearInterval(interval);
  }, [refresh]);

  const completeTodo = useCallback(
    async (id) => {
      await apiFetch("/complete", {
        method: "POST",
        body: JSON.stringify({ id }),
      });
      await refresh();
    },
    [refresh],
  );

  return { todos, nextPlan, loading, error, refresh, completeTodo };
}
